import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
import { Droppable } from '@hello-pangea/dnd';
import { jsx as _jsx } from "react/jsx-runtime";
function StrictModeDroppable(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    enabled = _useState2[0],
    setEnabled = _useState2[1];
  useEffect(function () {
    var animationFrame = requestAnimationFrame(function () {
      setEnabled(true);
    });
    return function () {
      cancelAnimationFrame(animationFrame);
    };
  }, []);
  if (!enabled) {
    return null;
  }
  return /*#__PURE__*/_jsx(Droppable, _objectSpread({}, props));
}
export default StrictModeDroppable;